 <template lang="pug">
  SspLayout(area="core")
    .row
      .col-md-5
        AtiSelect(v-model="ati")
      .col-sm-1
        button.btn.btn-primary(@click="addAti")
          i.fa.fa-plus
          span.ml5 Add
      .col-md-5
        AtiGroupSelect(v-model="atiGroupId")
      .col-sm-1
        button.btn.btn-primary(@click="addAtiGroup")
          i.fa.fa-plus
          span.ml5 Add

    DataGrid(:fetch="fetchData" :withoutPagination="true" ref="grid" style="margin-top: 10px")
      tr(slot="thead")
        th Name
        th Validity
        th Web Message
        th SMS Message
        th
      tr(v-for="ati in atis")
        td {{ati.name}}
        td
          span(v-show="ati.validationsRangeStart") {{ati.validationsRangeStart + 1}}
          span(v-show="!ati.validationsRangeStart") 1
          span &nbsp;to&nbsp;
          span(v-show="ati.validationsRangeEnd") {{ati.validationsRangeEnd + 1}}
          span(v-show="!ati.validationsRangeEnd") &infin;
        td
          div(v-show="ati.webMessage && ati.webMessage.length") {{ati.webMessage}}
        td {{ati.smsMessage}}
        td
          a.btn-trash(title="Unlink message", @click="unlinkAti(ati.id)")
</template>

<script>
import Core from '@/service/apis/Core'
import DataGrid from '@/components/ssp/DataGrid'
import AtiSelect from '@/components/ssp/AtiSelect'
import AtiGroupSelect from '@/components/ssp/AtiGroupSelect'

export default {
  data: () => ({
    ati: null,
    atiGroupId: null,
    atis: []
  }),
  methods: {
    addAti() {
      Core.applyAti(this.sectionId, this.ati.value)
        .then(() => {
          this.$refs.grid.reload(true)
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    addAtiGroup() {
      this.$confirm({ text: 'Applying messages group will overwrite existing messages. Do you want to continue?' })
        .then((conf) => {
          if (conf) {
            Core.applyAtiGroup(this.sectionId, this.atiGroupId)
              .then(() => {
                this.$refs.grid.reload(true)
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
    unlinkAti(atiId) {
      this.$confirm({ text: 'Are you sure you want to unlink this message?' })
        .then((conf) => {
          if (conf) {
            Core.unlinkAti(this.sectionId, atiId)
              .then(() => {
                this.$refs.grid.reload(true)
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          }
        })
    },
    fetchData() {
      return Core.listAtisBySectionId(this.sectionId)
        .then((l) => {
          this.atis = l.data.ati
          return l.data.ati.length
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
  },
  computed: {
    sectionId() {
      return parseInt(this.$route.params.sectionId, 10)
    },
    orderId() {
      return parseInt(this.$route.params.orderId, 10)
    }
  },
  components: {
    DataGrid,
    AtiSelect,
    AtiGroupSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/order/Messages.vue